// extracted by mini-css-extract-plugin
module.exports = {"codeExampleNotification":"CodeBlockComponents_codeExampleNotification__WdLqa"};